module.exports = __webpack_public_path__ + "static/media/notification_bell.d7b1106c.svg";